import { UserAuthService } from './../../services/user-auth.service';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { Router } from '@angular/router';

@Component({
	selector: 'app-not-available',
	templateUrl: './not-available.component.html',
	styleUrls: ['./not-available.component.scss'],
	imports: [
		MatCardModule,
		MatIconModule,
		MatButtonModule,
		FlexLayoutModule
	]
})
export class NotAvailableComponent {

	constructor(
		private readonly router: Router,
		private readonly userService: UserAuthService
	) { }

	public goHome(): void {
		let returnUrl = history.state?.returnUrl

		if (returnUrl)
			this.router.navigate([returnUrl]);
		else
			this.userService.goHome();
	}
}
